/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AboutRouteImport } from './routes/about'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AuthenticatedAppsRouteImport } from './routes/_authenticated/apps'
import { Route as AuthenticatedAppsEmbedRouteImport } from './routes/_authenticated/apps-embed'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedGridMapsRouteImport } from './routes/_authenticated/grid-maps'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated/notifications'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard/index'
import { Route as AuthenticatedDashboardFleetsRouteImport } from './routes/_authenticated/dashboard/fleets'
import { Route as AuthenticatedDashboardVesselsRouteImport } from './routes/_authenticated/dashboard/vessels'
import { Route as AuthenticatedDashboardAccountsRolesRouteImport } from './routes/_authenticated/dashboard/accounts/roles'
import { Route as AuthenticatedDashboardAccountsUsersRouteImport } from './routes/_authenticated/dashboard/accounts/users'
import { Route as AuthenticatedDashboardNotificationsHistoryRouteImport } from './routes/_authenticated/dashboard/notifications/history'
import { Route as AuthenticatedDashboardReportIndexRouteImport } from './routes/_authenticated/dashboard/report/index'
import { Route as AuthenticatedDashboardReportExpiredRouteImport } from './routes/_authenticated/dashboard/report/expired'
import { Route as AuthenticatedDashboardReportHistoryRouteImport } from './routes/_authenticated/dashboard/report/history'
import { Route as AuthenticatedDashboardReportListVoyageRouteImport } from './routes/_authenticated/dashboard/report/list-voyage'
import { Route as AuthenticatedDashboardReportRpmRouteImport } from './routes/_authenticated/dashboard/report/rpm'
import { Route as AuthenticatedDashboardReportVoyagerRouteImport } from './routes/_authenticated/dashboard/report/voyager'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAppsRoute = AuthenticatedAppsRouteImport.update({
  id: '/apps',
  path: '/apps',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAppsEmbedRoute = AuthenticatedAppsEmbedRouteImport.update({
  id: '/apps-embed',
  path: '/apps-embed',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedGridMapsRoute = AuthenticatedGridMapsRouteImport.update({
  id: '/grid-maps',
  path: '/grid-maps',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNotificationsRoute =
  AuthenticatedNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardFleetsRoute =
  AuthenticatedDashboardFleetsRouteImport.update({
    id: '/fleets',
    path: '/fleets',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardVesselsRoute =
  AuthenticatedDashboardVesselsRouteImport.update({
    id: '/vessels',
    path: '/vessels',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardAccountsRolesRoute =
  AuthenticatedDashboardAccountsRolesRouteImport.update({
    id: '/accounts/roles',
    path: '/accounts/roles',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardAccountsUsersRoute =
  AuthenticatedDashboardAccountsUsersRouteImport.update({
    id: '/accounts/users',
    path: '/accounts/users',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardNotificationsHistoryRoute =
  AuthenticatedDashboardNotificationsHistoryRouteImport.update({
    id: '/notifications/history',
    path: '/notifications/history',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardReportIndexRoute =
  AuthenticatedDashboardReportIndexRouteImport.update({
    id: '/report/',
    path: '/report/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardReportExpiredRoute =
  AuthenticatedDashboardReportExpiredRouteImport.update({
    id: '/report/expired',
    path: '/report/expired',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardReportHistoryRoute =
  AuthenticatedDashboardReportHistoryRouteImport.update({
    id: '/report/history',
    path: '/report/history',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardReportListVoyageRoute =
  AuthenticatedDashboardReportListVoyageRouteImport.update({
    id: '/report/list-voyage',
    path: '/report/list-voyage',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardReportRpmRoute =
  AuthenticatedDashboardReportRpmRouteImport.update({
    id: '/report/rpm',
    path: '/report/rpm',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardReportVoyagerRoute =
  AuthenticatedDashboardReportVoyagerRouteImport.update({
    id: '/report/voyager',
    path: '/report/voyager',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/apps': typeof AuthenticatedAppsRoute
  '/apps-embed': typeof AuthenticatedAppsEmbedRoute
  '/dashboard': typeof AuthenticatedDashboardRouteWithChildren
  '/grid-maps': typeof AuthenticatedGridMapsRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/dashboard/fleets': typeof AuthenticatedDashboardFleetsRoute
  '/dashboard/vessels': typeof AuthenticatedDashboardVesselsRoute
  '/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/dashboard/accounts/roles': typeof AuthenticatedDashboardAccountsRolesRoute
  '/dashboard/accounts/users': typeof AuthenticatedDashboardAccountsUsersRoute
  '/dashboard/notifications/history': typeof AuthenticatedDashboardNotificationsHistoryRoute
  '/dashboard/report/expired': typeof AuthenticatedDashboardReportExpiredRoute
  '/dashboard/report/history': typeof AuthenticatedDashboardReportHistoryRoute
  '/dashboard/report/list-voyage': typeof AuthenticatedDashboardReportListVoyageRoute
  '/dashboard/report/rpm': typeof AuthenticatedDashboardReportRpmRoute
  '/dashboard/report/voyager': typeof AuthenticatedDashboardReportVoyagerRoute
  '/dashboard/report/': typeof AuthenticatedDashboardReportIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/apps': typeof AuthenticatedAppsRoute
  '/apps-embed': typeof AuthenticatedAppsEmbedRoute
  '/grid-maps': typeof AuthenticatedGridMapsRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/dashboard/fleets': typeof AuthenticatedDashboardFleetsRoute
  '/dashboard/vessels': typeof AuthenticatedDashboardVesselsRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/dashboard/accounts/roles': typeof AuthenticatedDashboardAccountsRolesRoute
  '/dashboard/accounts/users': typeof AuthenticatedDashboardAccountsUsersRoute
  '/dashboard/notifications/history': typeof AuthenticatedDashboardNotificationsHistoryRoute
  '/dashboard/report/expired': typeof AuthenticatedDashboardReportExpiredRoute
  '/dashboard/report/history': typeof AuthenticatedDashboardReportHistoryRoute
  '/dashboard/report/list-voyage': typeof AuthenticatedDashboardReportListVoyageRoute
  '/dashboard/report/rpm': typeof AuthenticatedDashboardReportRpmRoute
  '/dashboard/report/voyager': typeof AuthenticatedDashboardReportVoyagerRoute
  '/dashboard/report': typeof AuthenticatedDashboardReportIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/_authenticated/apps': typeof AuthenticatedAppsRoute
  '/_authenticated/apps-embed': typeof AuthenticatedAppsEmbedRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRouteWithChildren
  '/_authenticated/grid-maps': typeof AuthenticatedGridMapsRoute
  '/_authenticated/notifications': typeof AuthenticatedNotificationsRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/dashboard/fleets': typeof AuthenticatedDashboardFleetsRoute
  '/_authenticated/dashboard/vessels': typeof AuthenticatedDashboardVesselsRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/dashboard/accounts/roles': typeof AuthenticatedDashboardAccountsRolesRoute
  '/_authenticated/dashboard/accounts/users': typeof AuthenticatedDashboardAccountsUsersRoute
  '/_authenticated/dashboard/notifications/history': typeof AuthenticatedDashboardNotificationsHistoryRoute
  '/_authenticated/dashboard/report/expired': typeof AuthenticatedDashboardReportExpiredRoute
  '/_authenticated/dashboard/report/history': typeof AuthenticatedDashboardReportHistoryRoute
  '/_authenticated/dashboard/report/list-voyage': typeof AuthenticatedDashboardReportListVoyageRoute
  '/_authenticated/dashboard/report/rpm': typeof AuthenticatedDashboardReportRpmRoute
  '/_authenticated/dashboard/report/voyager': typeof AuthenticatedDashboardReportVoyagerRoute
  '/_authenticated/dashboard/report/': typeof AuthenticatedDashboardReportIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/contact'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/apps'
    | '/apps-embed'
    | '/dashboard'
    | '/grid-maps'
    | '/notifications'
    | '/settings'
    | '/dashboard/fleets'
    | '/dashboard/vessels'
    | '/dashboard/'
    | '/dashboard/accounts/roles'
    | '/dashboard/accounts/users'
    | '/dashboard/notifications/history'
    | '/dashboard/report/expired'
    | '/dashboard/report/history'
    | '/dashboard/report/list-voyage'
    | '/dashboard/report/rpm'
    | '/dashboard/report/voyager'
    | '/dashboard/report/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/contact'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/apps'
    | '/apps-embed'
    | '/grid-maps'
    | '/notifications'
    | '/settings'
    | '/dashboard/fleets'
    | '/dashboard/vessels'
    | '/dashboard'
    | '/dashboard/accounts/roles'
    | '/dashboard/accounts/users'
    | '/dashboard/notifications/history'
    | '/dashboard/report/expired'
    | '/dashboard/report/history'
    | '/dashboard/report/list-voyage'
    | '/dashboard/report/rpm'
    | '/dashboard/report/voyager'
    | '/dashboard/report'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/about'
    | '/contact'
    | '/login'
    | '/privacy'
    | '/terms'
    | '/_authenticated/apps'
    | '/_authenticated/apps-embed'
    | '/_authenticated/dashboard'
    | '/_authenticated/grid-maps'
    | '/_authenticated/notifications'
    | '/_authenticated/settings'
    | '/_authenticated/dashboard/fleets'
    | '/_authenticated/dashboard/vessels'
    | '/_authenticated/dashboard/'
    | '/_authenticated/dashboard/accounts/roles'
    | '/_authenticated/dashboard/accounts/users'
    | '/_authenticated/dashboard/notifications/history'
    | '/_authenticated/dashboard/report/expired'
    | '/_authenticated/dashboard/report/history'
    | '/_authenticated/dashboard/report/list-voyage'
    | '/_authenticated/dashboard/report/rpm'
    | '/_authenticated/dashboard/report/voyager'
    | '/_authenticated/dashboard/report/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AboutRoute: typeof AboutRoute
  ContactRoute: typeof ContactRoute
  LoginRoute: typeof LoginRoute
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/apps': {
      id: '/_authenticated/apps'
      path: '/apps'
      fullPath: '/apps'
      preLoaderRoute: typeof AuthenticatedAppsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/apps-embed': {
      id: '/_authenticated/apps-embed'
      path: '/apps-embed'
      fullPath: '/apps-embed'
      preLoaderRoute: typeof AuthenticatedAppsEmbedRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/grid-maps': {
      id: '/_authenticated/grid-maps'
      path: '/grid-maps'
      fullPath: '/grid-maps'
      preLoaderRoute: typeof AuthenticatedGridMapsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notifications': {
      id: '/_authenticated/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/dashboard/fleets': {
      id: '/_authenticated/dashboard/fleets'
      path: '/fleets'
      fullPath: '/dashboard/fleets'
      preLoaderRoute: typeof AuthenticatedDashboardFleetsRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/dashboard/vessels': {
      id: '/_authenticated/dashboard/vessels'
      path: '/vessels'
      fullPath: '/dashboard/vessels'
      preLoaderRoute: typeof AuthenticatedDashboardVesselsRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/dashboard/accounts/roles': {
      id: '/_authenticated/dashboard/accounts/roles'
      path: '/accounts/roles'
      fullPath: '/dashboard/accounts/roles'
      preLoaderRoute: typeof AuthenticatedDashboardAccountsRolesRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/dashboard/accounts/users': {
      id: '/_authenticated/dashboard/accounts/users'
      path: '/accounts/users'
      fullPath: '/dashboard/accounts/users'
      preLoaderRoute: typeof AuthenticatedDashboardAccountsUsersRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/dashboard/notifications/history': {
      id: '/_authenticated/dashboard/notifications/history'
      path: '/notifications/history'
      fullPath: '/dashboard/notifications/history'
      preLoaderRoute: typeof AuthenticatedDashboardNotificationsHistoryRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/dashboard/report/': {
      id: '/_authenticated/dashboard/report/'
      path: '/report'
      fullPath: '/dashboard/report/'
      preLoaderRoute: typeof AuthenticatedDashboardReportIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/dashboard/report/expired': {
      id: '/_authenticated/dashboard/report/expired'
      path: '/report/expired'
      fullPath: '/dashboard/report/expired'
      preLoaderRoute: typeof AuthenticatedDashboardReportExpiredRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/dashboard/report/history': {
      id: '/_authenticated/dashboard/report/history'
      path: '/report/history'
      fullPath: '/dashboard/report/history'
      preLoaderRoute: typeof AuthenticatedDashboardReportHistoryRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/dashboard/report/list-voyage': {
      id: '/_authenticated/dashboard/report/list-voyage'
      path: '/report/list-voyage'
      fullPath: '/dashboard/report/list-voyage'
      preLoaderRoute: typeof AuthenticatedDashboardReportListVoyageRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/dashboard/report/rpm': {
      id: '/_authenticated/dashboard/report/rpm'
      path: '/report/rpm'
      fullPath: '/dashboard/report/rpm'
      preLoaderRoute: typeof AuthenticatedDashboardReportRpmRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/dashboard/report/voyager': {
      id: '/_authenticated/dashboard/report/voyager'
      path: '/report/voyager'
      fullPath: '/dashboard/report/voyager'
      preLoaderRoute: typeof AuthenticatedDashboardReportVoyagerRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
  }
}

interface AuthenticatedDashboardRouteChildren {
  AuthenticatedDashboardFleetsRoute: typeof AuthenticatedDashboardFleetsRoute
  AuthenticatedDashboardVesselsRoute: typeof AuthenticatedDashboardVesselsRoute
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
  AuthenticatedDashboardAccountsRolesRoute: typeof AuthenticatedDashboardAccountsRolesRoute
  AuthenticatedDashboardAccountsUsersRoute: typeof AuthenticatedDashboardAccountsUsersRoute
  AuthenticatedDashboardNotificationsHistoryRoute: typeof AuthenticatedDashboardNotificationsHistoryRoute
  AuthenticatedDashboardReportExpiredRoute: typeof AuthenticatedDashboardReportExpiredRoute
  AuthenticatedDashboardReportHistoryRoute: typeof AuthenticatedDashboardReportHistoryRoute
  AuthenticatedDashboardReportListVoyageRoute: typeof AuthenticatedDashboardReportListVoyageRoute
  AuthenticatedDashboardReportRpmRoute: typeof AuthenticatedDashboardReportRpmRoute
  AuthenticatedDashboardReportVoyagerRoute: typeof AuthenticatedDashboardReportVoyagerRoute
  AuthenticatedDashboardReportIndexRoute: typeof AuthenticatedDashboardReportIndexRoute
}

const AuthenticatedDashboardRouteChildren: AuthenticatedDashboardRouteChildren =
  {
    AuthenticatedDashboardFleetsRoute: AuthenticatedDashboardFleetsRoute,
    AuthenticatedDashboardVesselsRoute: AuthenticatedDashboardVesselsRoute,
    AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
    AuthenticatedDashboardAccountsRolesRoute:
      AuthenticatedDashboardAccountsRolesRoute,
    AuthenticatedDashboardAccountsUsersRoute:
      AuthenticatedDashboardAccountsUsersRoute,
    AuthenticatedDashboardNotificationsHistoryRoute:
      AuthenticatedDashboardNotificationsHistoryRoute,
    AuthenticatedDashboardReportExpiredRoute:
      AuthenticatedDashboardReportExpiredRoute,
    AuthenticatedDashboardReportHistoryRoute:
      AuthenticatedDashboardReportHistoryRoute,
    AuthenticatedDashboardReportListVoyageRoute:
      AuthenticatedDashboardReportListVoyageRoute,
    AuthenticatedDashboardReportRpmRoute: AuthenticatedDashboardReportRpmRoute,
    AuthenticatedDashboardReportVoyagerRoute:
      AuthenticatedDashboardReportVoyagerRoute,
    AuthenticatedDashboardReportIndexRoute:
      AuthenticatedDashboardReportIndexRoute,
  }

const AuthenticatedDashboardRouteWithChildren =
  AuthenticatedDashboardRoute._addFileChildren(
    AuthenticatedDashboardRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAppsRoute: typeof AuthenticatedAppsRoute
  AuthenticatedAppsEmbedRoute: typeof AuthenticatedAppsEmbedRoute
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRouteWithChildren
  AuthenticatedGridMapsRoute: typeof AuthenticatedGridMapsRoute
  AuthenticatedNotificationsRoute: typeof AuthenticatedNotificationsRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAppsRoute: AuthenticatedAppsRoute,
  AuthenticatedAppsEmbedRoute: AuthenticatedAppsEmbedRoute,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRouteWithChildren,
  AuthenticatedGridMapsRoute: AuthenticatedGridMapsRoute,
  AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AboutRoute: AboutRoute,
  ContactRoute: ContactRoute,
  LoginRoute: LoginRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
